export const isff =
  typeof navigator !== 'undefined'
    ? navigator.userAgent.toLowerCase().indexOf('firefox') > 0
    : false;

export function addEvent(
  dom: HTMLElement,
  event: string,
  method: EventListener
) {
  if (dom.addEventListener) {
    dom.addEventListener(event, method, false);
  } else if ((dom as any).attachEvent) {
    (dom as any).attachEvent(`on${event}`, () => {
      method(window.event as any);
    });
  }
}

// 修饰键转换成对应的键码
export function getMods(modifier: any, key: string[]) {
  return key
    .slice(0, key.length - 1)
    .map((mod: string) => modifier[mod.toLowerCase()]);
}

// 处理传的key字符串转换成数组
export function getKeys(key: string) {
  if (!key) {
    return [];
  }

  const keys = key.replace(/\s/g, '').split(',');
  let splitContextIndex = keys.lastIndexOf('');

  while (splitContextIndex > 0) {
    keys[splitContextIndex - 1] += ',';
    keys.splice(splitContextIndex, 1);
    splitContextIndex = keys.lastIndexOf('');
  }

  return keys;
}

export function compareArray(a1: any[], a2: any[]) {
  const arr1 = a1.length > a2.length ? a1 : a2;
  const arr2 = a1.length > a2.length ? a2 : a1;
  let isSame = true;

  for (const item of a1) {
    if (arr2.indexOf(arr2) !== -1) {
      isSame = false;
      break;
    }
  }

  return isSame;
}
